import {
  IFocalLayerRepository,
  FocalLayerEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class FocalLayerRepository implements IFocalLayerRepository {
  async getLayers(): Promise<ResponseValueObject<FocalLayerEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'conflicto',  name: 'Conflicto activo',     icon: '⚡', visible: true },
      { id: 'rios',       name: 'Cochas / Rios',        icon: '〜', visible: true },
      { id: 'lagunas',    name: 'Lagunas',              icon: '◈',  visible: false },
      { id: 'reservorios', name: 'Reservorios',         icon: '▣',  visible: false },
      { id: 'cpoblados',  name: 'Centros Poblados',     icon: '⫿',  visible: true },
      { id: 'cnativas',   name: 'Com. Nativas',         icon: '◕',  visible: false },
      { id: 'minera',     name: 'Act. Minera',          icon: '⛏',  visible: false },
      { id: 'escuelas',   name: 'Escuelas',             icon: '🏫', visible: false },
      { id: 'salud',      name: 'Puestos Salud',        icon: '🏥', visible: false },
    ]);
  }
}
